import React from "react";
import {validateForm} from "../../Components/ValidateForm/Validator";
import {useTranslation} from "react-i18next";
const CompanyModal = ({ show, handleClose, formData, setFormData, handleInputChange, handleSave, logo, setLogo, regions }) => {
    const {t} = useTranslation();
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && (file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif")) {
            let newFormData = { ...formData };
            newFormData.logo = file;
            setFormData(newFormData);
            setLogo(URL.createObjectURL(file));
        } else {
            alert(t('image_request'));
        }
    };
    const handleValidatedSave = () => {
        let errors = validateForm(formData, t);
        if (errors.length > 0) {
            alert(errors.join("\n"));
            return;
        }
        handleSave();
    };
    const handleDeleteImage = () => {
        setLogo(null);
        const newFormData = { ...formData, logo: '' };
        setFormData(newFormData);
    };

    const handleViewImage = () => {
        if (logo) {
            window.open(logo, "_blank");
        }
    };
    return (
            <div
                className={`modal fade ${show ? "show" : ""}`}
                id="editModal"
                tabIndex="-1"
                aria-labelledby="editModalLabel"
                style={{ display: show ? "block" : "none" , background: "rgba(0, 0, 0, 0.65)"}}
            >
                <div className="modal-dialog" style={{maxWidth:"1230px"}}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="editModalLabel">
                                {t('edit_data')}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={handleClose}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid" style={{width: "1200px"}}>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="mb-3">
                                            <label htmlFor="name" className="form-label">
                                                {t('translation:company_name')}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                name="name"
                                                value={formData?.name || ""}
                                                onChange={handleInputChange}
                                                placeholder={t('translation:company_name')}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="type" className="form-label">
                                                {t('translation:company_type')}
                                            </label>
                                            <select
                                                id="type"
                                                name="type"
                                                className="form-select"
                                                value={formData.type}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option value="">-- {t('choose')} --</option>
                                                <option value='Loyihalovchi'>{t('Loyihalovchi')}</option>
                                                <option value='Quruvchi korxona'>{t('Quruvchi korxona')}</option>
                                                <option value='Ishlab chiqaruvchi'>{t('Ishlab chiqaruvchi')}</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="address" className="form-label">
                                                {t('translation:company_legal_address')}
                                            </label>
                                            <textarea
                                                className="form-control"
                                                id="address"
                                                name="address"
                                                value={formData?.address || ''}
                                                onChange={handleInputChange}
                                                placeholder={t('translation:company_legal_address')}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="phone" className="form-label">
                                                {t('translation:company_phone')}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="phone"
                                                name="phone"
                                                value={formData?.phone || ""}
                                                onChange={handleInputChange}
                                                placeholder={t('translation:company_phone')}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="email" className="form-label">
                                                {t('translation:company_email')}
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                name="email"
                                                value={formData?.email || ""}
                                                onChange={handleInputChange}
                                                placeholder={t('translation:company_email')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="mb-3">
                                            <label htmlFor="site" className="form-label">
                                                {t('translation:company_website')}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="site"
                                                name="site"
                                                value={formData?.site || ""}
                                                onChange={handleInputChange}
                                                placeholder={t('translation:company_website')}
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="regionId" className="form-label">
                                                {t('translation:company_region')}
                                            </label>
                                            <select
                                                id="regionId"
                                                name="region"
                                                className="form-select"
                                                value={formData.region}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option value="">-- {t('translation:choose')} --</option>
                                                {
                                                    regions && regions.length ?
                                                        regions.map((region) => (
                                                            <option key={region.id} value={region.id}>
                                                                {region.name_l}
                                                            </option>
                                                        ))
                                                        : <option value={t('translation:no_data_found')}>
                                                            {t('translation:no_data_found')}
                                                        </option>
                                                }
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="bank" className="form-label">
                                                {t('translation:company_bank')}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="bank"
                                                name="bank"
                                                value={formData?.bank || ""}
                                                onChange={handleInputChange}
                                                placeholder={t('translation:company_bank')}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="mfo" className="form-label">
                                                {t('translation:mfo')}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="mfo"
                                                name="mfo"
                                                value={formData?.mfo || ""}
                                                onChange={handleInputChange}
                                                placeholder={t('translation:mfo')}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="stir" className="form-label">
                                                {t('translation:stir')}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="stir"
                                                name="stir"
                                                value={formData?.stir || ""}
                                                onChange={handleInputChange}
                                                placeholder={t('translation:stir')}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="xtut" className="form-label">
                                                {t('translation:xtut_code')}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="xtut"
                                                name="xtut"
                                                value={formData?.xtut || ""}
                                                onChange={handleInputChange}
                                                placeholder={t('translation:xtut_code')}
                                            />
                                        </div>

                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-3">
                                        <label htmlFor="fileInput">{t('translation:company_logo')}</label>
                                        <div className="changeLogoBlock">
                                            {logo ? (
                                                <>
                                                    <img src={logo} style={{maxWidth: "100%", maxHeight: "100%"}}
                                                         alt="Logo"/>
                                                    <div className="icons">
                                                        <i className="bi bi-cloud-arrow-up"
                                                           onClick={() => document.getElementById('fileInput').click()}
                                                           style={{margin: '5px', cursor: 'pointer'}}/>
                                                        <i className="bi bi-eye" onClick={handleViewImage}
                                                           style={{margin: '5px', cursor: 'pointer'}}/>
                                                        <i className="bi bi-trash" onClick={handleDeleteImage}
                                                           style={{margin: '5px', cursor: 'pointer'}}/>
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="no_logo" onClick={() => document.getElementById('fileInput').click()}
                                                     style={{margin: '5px', cursor: 'pointer'}}>
                                                    <i className="bi bi-upload"/>
                                                    <p>{t('upload_logo')}</p>
                                                </div>
                                            )}

                                            <input
                                                type="file"
                                                id="fileInput"
                                                style={{display: "none"}}
                                                accept="image/jpeg, image/png, image/gif"
                                                onChange={handleFileChange}
                                                name="logo"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-9">
                                        <div className="mb-3">
                                            <label htmlFor="about" className="form-label">
                                                {t('translation:about_company')}
                                            </label>
                                            <textarea
                                                className="form-control"
                                                id="about"
                                                name="about"
                                                rows="3"
                                                value={formData?.about || ""}
                                                onChange={handleInputChange}
                                                placeholder={t('translation:about_company')}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                {t('cancel')}
                            </button>
                            <button type="button" className="btn btn-primary" onClick={handleValidatedSave}>
                                {t('save')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default CompanyModal;
